export default __webpack_public_path__ + "static/media/Cool_Vibes.6b2d310d.mp3";